import React from "react";
import { IssueBox } from "./IssueBox";
import { formatDateLabel } from "../../utils/issueDateFormat";
import css from "./IssueLayoutTier1.module.css";
export var IssueLayoutTier1 = function (_a) {
    var issues = _a.issues, onIssueClick = _a.onIssueClick, onLinkedVolumeClick = _a.onLinkedVolumeClick;
    return (React.createElement("div", { className: css.row }, issues.map(function (iss) { return (React.createElement(IssueBox, { key: iss.id, issue: iss, onClick: onIssueClick, onLinkedVolumeClick: onLinkedVolumeClick, dateLabel: formatDateLabel(iss.expectedDate, 1) })); })));
};
